import { OrdersComponent } from './orders.component';
import { OrderFileComponent } from './order-file';
import { OrdersOnlineComponent } from './order-online';
import { ProceduresComplainComponent } from './procedures-complain';
import { ProceduresIntroduceComponent } from './procedures-introduce';
import { ProceduresPaymentComponent } from './procedures-payment';
import { ProceduresOrderComponent } from './procedures-order';

export const routes = [
  { path: '', component: OrdersComponent, children: [
    { path: '', redirectTo: 'gioi-thieu', pathMatch: 'full' },
    { path: 'dat-hang-theo-mau', component: OrderFileComponent },
    { path: 'dat-hang-online', component: OrdersOnlineComponent },
    { path: 'gioi-thieu', component: ProceduresIntroduceComponent },
    { path: 'khieu-nai', component: ProceduresComplainComponent },
    { path: 'dat-hang', component: ProceduresOrderComponent },
    { path: 'thanh-toan', component: ProceduresPaymentComponent },
  ]},
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/orders/orders.routes.ts